module.exports = "observation-inherited"